export const receiptCategories = [
  { value: 0, label: 'Show All Active Receipts' },
  { value: 1, label: 'Show All Receipts' },
  { value: 2, label: 'Show Qty-Variance < 100%' },
  { value: 3, label: 'Show Qty-Variance >= 100%' },
  { value: 4, label: 'Show Complete' },
  { value: 5, label: 'Show Deleted' },
  { value: 6, label: 'Show Pending Receipt Goods' },
  { value: 7, label: 'Show Only Create New' },
];
